import {Confirm, useOpenModal} from '@/components/Modal/index.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const openModal = useOpenModal()
    const map = useMapContext()
    const permission = map.usePermission()
    map.useNodeChange(map.root, ['data'])
    const {canUndoReviseProduct, undoReviseProduct} = map.commands
    const nodes = canUndoReviseProduct([map.root])

    if (
        0 === nodes.length ||
        ! permission.has('revise')
    ) {
        return null
    }

    const onClick = async () => {
        const isConfirmed = await openModal(
            <Confirm>
                确定撤销修订？（撤销修订后，模型将恢复至最近一次发布版）
            </Confirm>
        )

        if (isConfirmed) {
            undoReviseProduct(nodes)
        }
    }

    return {
        key: 'undo-revise-product',
        label: '撤销修订制品',
        onClick,
    }
}
